import type { ObjectType, ShaderDataTypeKeys } from "models-webgl2";
import { Webgl2ShadersKeys, Webgl2MaterialsKeys } from "./webgl2.types";

import {
  bgColorVertexShader,
  bgColorFragmentShader,
  blurVertexShader,
  blurFragmentShader,
  brushToolVertexShader,
  brushToolFragmentShader,
  defaultVertexShader,
  defaultFragmentShader,
  chessGridVertexShader,
  chessGridFragmentShader,
  circleVertexShader,
  circleFragmentShader,
  lineGridVertexShader,
  lineGridFragmentShader,
  pickingVertexShader,
  pickingFragmentShader,
  retouchToolVertexShader,
  retouchToolFragmentShader,
  retouchMaskVertexShader,
  retouchMaskFragmentShader,
  retouchPreviewVertexShader,
  retouchPreviewFragmentShader,
  selectionControlVertexShader,
  selectionControlFragmentShader,
  selectionGridVertexShader,
  selectionGridFragmentShader,
  textureVertexShader,
  textureFragmentShader,
  transparentVertexShader,
  transparentFragmentShader,
} from "assets/shaders";

export const webgl2ShadersMap: ObjectType<
  [vertex: string, fragment: string],
  Webgl2ShadersKeys | Webgl2MaterialsKeys
> = {
  backgroundColor: [bgColorVertexShader, bgColorFragmentShader],
  blur: [blurVertexShader, blurFragmentShader],
  brush: [brushToolVertexShader, brushToolFragmentShader],
  default: [defaultVertexShader, defaultFragmentShader],
  chessGrid: [chessGridVertexShader, chessGridFragmentShader],
  circle: [circleVertexShader, circleFragmentShader],
  lineGrid: [lineGridVertexShader, lineGridFragmentShader],
  picking: [pickingVertexShader, pickingFragmentShader],
  retouch: [retouchToolVertexShader, retouchToolFragmentShader],
  retouchMask: [retouchMaskVertexShader, retouchMaskFragmentShader],
  retouchPreview: [retouchPreviewVertexShader, retouchPreviewFragmentShader],
  selectionControl: [selectionControlVertexShader, selectionControlFragmentShader],
  selectionGrid: [selectionGridVertexShader, selectionGridFragmentShader],
  texture: [textureVertexShader, textureFragmentShader],
  transparent: [transparentVertexShader, transparentFragmentShader],
};

const INT = 0x1404;
const FLOAT = 0x1406;
const BOOL = 0x8b56;

export const SHADER_DATA_TYPE_TO_WEBGL_BASE_TYPE: Record<ShaderDataTypeKeys, number> = {
  float: FLOAT,
  vec2: FLOAT,
  vec3: FLOAT,
  vec4: FLOAT,
  mat3: FLOAT,
  mat4: FLOAT,
  uint: INT, // UINT
  int: INT,
  sampler2D: INT,
  ivec2: INT,
  ivec3: INT,
  ivec4: INT,
  bool: BOOL,
};

export const SHADER_DATA_TYPE_SIZE: Record<ShaderDataTypeKeys, number> = {
  float: 4,
  vec2: 8, // 4 * 2
  vec3: 12, // 4 * 3
  vec4: 16, // 4 * 4
  mat3: 36, // 4 * 3 * 3
  mat4: 64, // 4 * 4 * 4
  uint: 4,
  int: 4,
  sampler2D: 4,
  ivec2: 8, // 4 * 2
  ivec3: 12, // 4 * 3
  ivec4: 16, // 4 * 4
  bool: 1,
};

export const SHADER_DATA_TYPE_COUNT: Record<ShaderDataTypeKeys, number> = {
  float: 1,
  vec2: 2,
  vec3: 3,
  vec4: 4,
  mat3: 9, // 3 * 3
  mat4: 16, // 4 * 4
  uint: 1,
  int: 1,
  sampler2D: 1,
  ivec2: 2,
  ivec3: 3,
  ivec4: 4,
  bool: 1,
};
